import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Text, useTheme } from '@rneui/themed';

export const StdUnitStepper = ({ icon, value, add, overDayLimit }) => {
  const { theme } = useTheme();

  return (
    <View style={styles.stdUnitView}>
      <Text
        style={[
          styles.amountTextStyle,
          {
            color: overDayLimit ? theme.colors.secondary : theme.colors.primary,
          },
        ]}
      >
        {value || 0}
      </Text>
      {icon}
      <View style={{ marginTop: 20 }}>
        <TouchableOpacity onPress={() => add(1)}>
          <View
            style={[
              styles.plusMinusView,
              { borderColor: theme.colors.primary },
            ]}
          >
            <Text
              style={[
                styles.plusMinusText,
                { color: theme.colors.primary, left: 16 },
              ]}
            >
              +
            </Text>
          </View>
        </TouchableOpacity>
        <TouchableOpacity onPress={() => add(-1)} disabled={!value}>
          <View
            style={[
              styles.plusMinusView,
              { borderColor: theme.colors.primary },
            ]}
          >
            <Text
              style={[
                styles.plusMinusText,
                { color: theme.colors.primary, left: 19 },
              ]}
            >
              -
            </Text>
          </View>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  stdUnitView: { flex: 1, alignItems: 'center', padding: 5 },
  plusMinusView: {
    borderWidth: 2,
    borderRadius: 30,
    width: 60,
    height: 60,
    marginBottom: 20,
  },
  plusMinusText: { fontSize: 40, position: 'absolute', top: 3 },
  amountTextStyle: { fontSize: 40, marginBottom: 10 },
});
